import React from 'react';

function EllipsisIcon() {
    return (
        <>
            <svg
                width="60"
                height="12"
                viewBox="0 0 60 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle opacity="0.75" cx="6" cy="6" r="6" fill="#05668D" />
                <circle cx="30" cy="6" r="6" fill="#D9D9D9" />
                <circle cx="54" cy="6" r="6" fill="#D9D9D9" />
            </svg>
        </>
    );
}

export default EllipsisIcon;
